// extracted by mini-css-extract-plugin
export default {"chatBox":"ChatBox_chatBox__Trglt","chatBoxArrow":"ChatBox_chatBoxArrow__JmuYx","chatBoxQuestion":"ChatBox_chatBoxQuestion__3-aqD"};